<template>
  <el-dialog
    title="检查题目数据并修复"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="600px"
    @keyup.enter.native="onSubmit()">
    <el-table :data="table"
              stripe
              highlight-current-row
              border
              style="width: 100%">
      <el-table-column label="问题">
        <template slot-scope="scope">
          <el-tooltip effect="dark"
                      :content="scope.row.question.title"
                      placement="top">
            <span>Q{{scope.row.questionIndex+1}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="选项">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.option"
                      effect="dark"
                      :content="scope.row.option.title"
                      placement="top">
            <span>OPT{{scope.row.optionIndex+1}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="参考目标">
        <template slot-scope="scope">
          <span v-if="scope.row.referIds === true">正常</span>
          <span v-else-if="scope.row.referIds === false"
                class="color-danger">不存在</span>
          <span v-else>未选择</span>
        </template>
      </el-table-column>
      <el-table-column label="跳转目标">
        <template slot-scope="scope">
          <span v-if="scope.row.isExistJumpTargetId === true">正常</span>
          <span v-else-if="scope.row.isExistJumpTargetId === false && scope.row.jumpTargetId === 'end'"
                class="color-danger">不能和结束答题共用</span>
          <span v-else-if="scope.row.isExistJumpTargetId === false"
                class="color-danger">不存在</span>
          <span v-else-if="scope.row.isExistJumpToExtendedStep === true"
                class="color-danger">显示题和隐藏题之间不能有逻辑跳转</span>
          <span v-else>未选择</span>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="visible = false">手动清理</el-button>
      <el-button type="primary"
                 @click="onSubmit()">清理并保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      visible: false,
      table: [],
      submit: () => {},
    }
  },
  computed: {},
  watch: {
    visible () {
      if (!this.visible) {
        Object.assign(this.$data, this.$options.data())
      }
    },
  },
  created () {},
  mounted () {},
  methods: {
    open (table, callback) {
      this.table = table
      this.visible = true
    },
    onSubmit () {
      this.submit()
      this.visible = false
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/step-template/components/CheckQuestionFix.vue